import { render, staticRenderFns } from "./ShoppingCartComponent.vue?vue&type=template&id=2e344865"
import script from "./ShoppingCartComponent.vue?vue&type=script&lang=js"
export * from "./ShoppingCartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports